import time from '../../time/time';
import DataItem from '../common/data-item';

export default class DurationDataItem extends DataItem {
  constructor(appName, overrideFieldName) {
    const duration = Math.floor(time.appLoadTime(appName));
    const durationParamName = overrideFieldName
      ? overrideFieldName
      : 'duration';

    super({
      [durationParamName]: duration,
    });
    this.appName = appName;
  }

  setFirstRequestDuration() {
    this.data.frd = Math.floor(time.firstRequestDuration(this.appName));
    return this;
  }
}
